<template>
  <group-cart v-if="orderDetails.orderType === 'group'" />
  <standard-cart v-else-if="orderDetails.orderType === 'standard' || orderDetails.orderType === 'catering'" />
  <table-cart v-else-if="orderDetails.orderType === 'table'" />
</template>


<script>
  import { mapGetters } from 'vuex';

  import GroupCart from './group-cart.vue';
  import StandardCart from './standard-cart.vue';
  import TableCart from './table-cart.vue';

  export default {
    name: 'Cart',

    components: {
      GroupCart,
      StandardCart,
      TableCart
    },

    computed: {
      ...mapGetters('session', ['orderDetails'])
    }
  };
</script>
